// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "HomeSettingsModule__textCenter__cTTr1";
export const table = "HomeSettingsModule__table__P0xEk";
export const tableInner = "HomeSettingsModule__tableInner__lw42Y";
export const headerRow = "HomeSettingsModule__headerRow__8rZ5y";
export const white = "HomeSettingsModule__white__2udgA";
export const headerCell = "HomeSettingsModule__headerCell__OT12g";
export const responsiveTitle = "HomeSettingsModule__responsiveTitle__TvoY+";
export const responsiveTitleText = "HomeSettingsModule__responsiveTitleText__ti+oC";
export const headerTitle = "HomeSettingsModule__headerTitle__vXD3W";
export const sortingWrapper = "HomeSettingsModule__sortingWrapper__XmiLj";
export const withHelpText = "HomeSettingsModule__withHelpText__wgvgo";
export const up = "HomeSettingsModule__up__gyJ7V";
export const down = "HomeSettingsModule__down__Qku4U";
export const body = "HomeSettingsModule__body__3tHDK";
export const row = "HomeSettingsModule__row__LaFB5";
export const cell = "HomeSettingsModule__cell__Cw1TH";
export const footer = "HomeSettingsModule__footer__Cl-VM";
export const paginatorWrapper = "HomeSettingsModule__paginatorWrapper__N6YRc";
export const pageSizeSelectorWrapper = "HomeSettingsModule__pageSizeSelectorWrapper__wU3jZ";
export const tooltipIconWrapper = "HomeSettingsModule__tooltipIconWrapper__tgMxh";
export const debtsAccountDetails = "HomeSettingsModule__debtsAccountDetails__KQFK3";
export const creditAccountDetails = "HomeSettingsModule__creditAccountDetails__gc5eR";
export const accountsTable = "HomeSettingsModule__accountsTable__ndatm";
export const pointing = "HomeSettingsModule__pointing__928KQ";
export const emptyState = "HomeSettingsModule__emptyState__DiMo8 BalanceAccountSettingsModule__emptyState__shYhk";
export const homesTable = "HomeSettingsModule__homesTable__7uy6o";
export const visibleOneColumnUp = "HomeSettingsModule__visibleOneColumnUp__eshcL";